import React from "react";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { Link } from "../../components/Link";
import "./styles.less";

export const Log = () => {
  const editionData = [
    {
      edition: "版本：2.0.1",
      date: "2021/10/30",
      items: [
        {
          title:
            "新增应用管理员角色，字段管理升级，上线新手引导，新增社交身份源，合作网络新增主流应用",
          items: [
            "协作管理员优化：新增应用管理员角色，支持应用级别管理员权限分配，优化交互体验细节。",
            "字段管理升级：新增支持控制台、个人中心是否可见字段、新增用户是否可以编辑、是否唯一等配置能力。",
            "上线新手引导：新增「试试登录框」、「将 Authing 嵌入到你的应用」、「连接身份源」、「保护你的应用安全」、「开启应用面板」、「逛逛应用市场」引导模块。",
            "新增社交身份源：新增 Linkedin、Slack、Facebook 社交身份源。",
            "合作网络新增应用：Jumpserver、Dropbox、Splunk、腾讯云用户 SSO、Salesforce 身份供给。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/09/30",
      items: [
        {
          title:
            "合作网络新增支持多个主流应用，Authing 业务中心迭代、控制台审计日志新版上线、同步中心迭代、业务中心迭代",
          items: [
            "合作网络增加金山云、SAP 等 6 个应用以及集成应用的教程指南。",
            "Authing 业务中心 UI、交互风格统一。",
            "Authing 控制台审计日志优化日志数据结构、数据交互与数据展示。",
            "Authing 同步中心- 管理员可以通过「同步中心」完成组织机构和用户信息的增量同步，更新功能包括：测试联通、同步字段映射、同步配置。",
            "Authing 控制台概览页增加数据展示维度，优化图表展示样式，连接身份源功能优化，应用配置优化，用户授权优化。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/08/27",
      items: [
        {
          title:
            "合作网络新增支持多个主流应用，Authing 控制台用户列表搜索能力、用户自助注销能力上线",
          items: [
            "合作网络增加 Moka、飞连、百度智能云等 7 个应用以及集成应用的教程指南。",
            "用户列表搜索能力上线：支持快捷切换字段进行搜索；支持添加更多筛选条件进行复杂搜索；新增以用户「登录过的应用」维度进行用户筛选。",
            "用户自助注销能力上线：户在个人中心页面，支持账号注销能力，永久性删除账号。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/07/30",
      items: [
        {
          title:
            "合作网络新增支持多个主流应用，身份供应上线，上线 JWE ID Token 加密配置能力",
          items: [
            "合作网络新增 Adobe、北森等 16 个应用以及集成应用的教程指南。",
            "身份供应上线，管理员可以通过合作网络，设置第三方集成应用，向下游应用灵活地自定义提供用户身份供应。",
            "上线 JWE ID Token 加密配置能力，支持多种加密算法。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/07/03",
      items: [
        {
          title:
            "合作网络新增支持多个主流应用，支持连接 ADFS，登录页面性能优化",
          items: [
            "合作网络上架 Jenkins、Slack、WordPress、Seafile、Kibana、Teambition、Salesforce，简单配置即可集成这些应用。",
            "支持连接 ADFS 身份源，5 个步骤快速完成对接。",
            "上线密码轮换，支持自定义密码函数策略，更好地提升应用与账号安全性与配置能力。",
            "应用面板 UI 改版，上线应用面板引导与配置功能，帮助企业快速上手配置与使用。",
            "Golang SDK 持续完善，上线用户管理、组织管理、角色管理相关接口。",
            "登录页面性能优化，组织机构查询效率提升 50%，登录页面加载速度提升 60%。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/06/20",
      items: [
        {
          title: "支持 Facebook、Twitter 登录，合作网络新增支持多个主流应用",
          items: [
            "Authing 社会化登录已支持 Facebook、Twitter。",
            "合作网络新增支持集成 Confluence、GitHub、Google Workspace、Zoom、Jira 等。",
            "上线新版的 Golang SDK，加强了 Authing 的开发者友好性。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/06/06",
      items: [
        {
          title:
            "合作网络上架飞书等应用，控制台新增「安全管理」菜单，CAS 协议迭代",
          items: [
            "合作网络上架飞书、GitLab 和 zabbix，简单配置即可集成这些应用。",
            "控制台新增「安全管理」菜单，能在这里配置所有安全信息，同时新增「密码安全策略」功能，能够锁定登录错误次数过多的用户账号。",
            "CAS 协议迭代，支持更加完善的 CAS 2.0 协议。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/05/22",
      items: [
        {
          title:
            "合作网络上线，上线快速开始文档，用户个人中心适配移动端、Pad 端，管理员创建用户迭代优化，自定义密码强度支持自定义正则表达式",
          items: [
            "合作网络上线，企业管理员可以极速完成应用单点登录。",
            "上线 Vue、Angular、Java Spring Boot 快速开始文档。",
            "用户个人中心适配移动端、Pad 端。",
            "管理员创建用户迭代优化，支持自动生成密码，强制用户首次登录修改密码。",
            "自定义密码强度支持自定义正则表达式。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/05/08",
      items: [
        {
          title:
            "Authing 论坛上线，文档上线「快速开始」模块，组织机构管理 UI 升级，Python SDK 大升级，支持飞书组织机构导入",
          items: [
            "Authing 论坛上线，致力打造更高效的技术交流和资源共享平台。",
            "文档上线「快速开始」模块。",
            "组织机构管理 UI 升级。",
            "Python SDK 大升级，更新 200 余个方法。",
            "支持飞书组织机构导入。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/04/25",
      items: [
        {
          title:
            "新增 19 个用户、组织结构等相关的 webhook，PHP, Java, SDK 大升级，GitLab 支持通过 OIDC 协议使用 Authing 登录",
          items: [
            "新增 19 个用户、组织结构等相关的 webhook。",
            "PHP, Java, SDK 大升级，更新 200 余个方法。",
            "GitLab 支持通过 OIDC 协议使用 Authing 登录。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/04/10",
      items: [
        {
          title:
            "企业 MFA 支持人脸和 OTP，注册协议支持多语言，AD 双向同步，gitlab 社会化登录",
          items: [
            "企业 MFA 支持人脸和 OTP。",
            "注册协议支持多语言。",
            "AD 双向同步。",
            "支持 gitlab 社会化登录。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/03/27",
      items: [
        {
          title:
            "支持飞书社会化登录，分组管理、注册白名单和角色详情 UI 升级，SDK 持续迭代，支持单点登录和标准协议",
          items: [
            "支持飞书社会化登录，包含企业自建应用和飞书应用商店应用。",
            "分组管理、注册白名单和角色详情 UI 升级，增强用户体验。",
            "SDK 持续迭代，支持单点登录和标准协议。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/03/13",
      items: [
        {
          title:
            "Authing 文档 2.0 上线，用户详情页面升级，迭代优化 LDAP 认证、组织机构同步能力，新增 20+ webhook，支持 CAS IdP",
          items: [
            "Authing 文档 2.0 上线，结构更加清晰，用户体验更加友好。",
            "用户详情页面升级，用户信息按类聚合，更加清晰。",
            "迭代优化 LDAP 认证、组织机构同步能力。",
            "新增 20+ webhook，方便开发者对事件及时响应。",
            "支持 CAS IdP，能将应用作为 CAS 身份提供商。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/02/27",
      items: [
        {
          title:
            "注册页面支持配置自定义的服务条款，外部链接和由 Authing 托管，反向代理的模式支持自定义域名，JS SDK 支持 CDN 引用",
          items: [
            "注册页面支持配置自定义的服务条款，支持外部链接和由 Authing 托管两种模式。",
            "可以通过反向代理的模式支持自定义域名。",
            "JS SDK 支持 CDN 引用。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/01/30",
      items: [
        {
          title:
            "集成 Sendgrid 邮件服务商，应用配置页面、设置配置页面交互体验优化",
          items: [
            "集成 Sendgrid 邮件服务商。",
            "应用配置页面、设置配置页面交互体验优化。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/01/16",
      items: [
        {
          title:
            "上线用户自定义数据库的认证模式，上线个人账户安全等级功能，权限交互体验升级",
          items: [
            "上线完全使用用户自定义数据库的认证模式，可以查看请求的数据库连接和查询日志。",
            "上线个人账户安全等级功能，基于密码强度、邮箱手机绑定情况进行综合评分。",
            "权限交互体验升级，资源定义和权限授权流程更加易用。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2021/01/01",
      items: [
        {
          title:
            "OTP 多因素认证，应用子账号配置，用户主体认证，权限分组功能，用户登录状态管理",
          items: [
            "上线邮箱和手机两种模式的 OTP 多因素认证。",
            "支持配置应用级别子账号，子账号可以独立认证。",
            "支持个人认证、企业认证两种用户主体认证。",
            "上线权限分组功能，将角色、资源、策略、授权功能统一分组管理。",
            "上线基于属性的授权模式，可以基于当前用户信息、网络信息、时间等信息来进行细粒度授权。",
            "支持应用级别用户登录状态管理，可以对指定用户进行强制下线操作。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2020/12/19",
      items: [
        {
          title:
            "LDAP 身份源能力升级，上线应用授权功能，上线应用级别用户日志审计",
          items: [
            "LDAP 身份源能力升级：支持自定义搜索范围；支持返回角色、分组、组织机构这三个扩展字段；支持过滤用户字段。",
            "上线应用授权功能，可以配置用户、角色、组织等不同范围的权限控制。",
            "上线应用级别用户日志审计，在概览页面可以观察各个应用的增长趋势。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2020/12/04",
      items: [
        {
          title: "支持支付宝扫码登录，上线 SCIM 同步中心，上线自定义数据库连接",
          items: [
            "支持支付宝扫码登录。",
            "上线 SCIM 同步中心，实现不同域之间账号和组织数据同步。",
            "上线自定义数据库连接，可以通过不停机的方式将用户数据惰性迁移到 Authing。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2020/11/21",
      items: [
        {
          title:
            "新增 Oauth 2.0 自定义社会化登录，上线新版登录注册表单组件（Guard）",
          items: [
            "新增社会化登录方式，上线基于 OAuth 2.0 的自定义社会化登录，支持 Apple 社会化登录。",
            <div>
              上线新版登录注册表单组件，支持单点登录功能，并在 Github 上开源。
              <Link
                href="https://github.com/Authing/authing-ui-components"
                rel="noopener noreferrer"
                target="_blank"
              >
                Github 访问链接
              </Link>
              。
            </div>,
            <div>
              支持私有网络下的 Windows Activity Directory 连接。详情请查看
              <Link
                href="https://docs.authing.cn/v2/connections/windows-active-directory/"
                rel="noopener noreferrer"
                target="_blank"
              >
                文档
              </Link>
              。
            </div>,
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2020/11/07",
      items: [
        {
          title: "新增多种身份源连接，LDAP 功能增强",
          items: [
            <div>
              上线 Azure AD 身份源连接，可以通过 Azure
              用户目录进行身份认证。详情请查看
              <Link
                href="https://docs.authing.cn/v2/connections/azure-active-directory/"
                rel="noopener noreferrer"
                target="_blank"
              >
                文档
              </Link>
              。
            </div>,
            <div>
              LDAP 新增字段过滤和属性过滤功能，并且支持更多查找模式。详情请查看
              <Link
                href="https://docs.authing.cn/v2/guides/users/ldap-user-directory.html"
                rel="noopener noreferrer"
                target="_blank"
              >
                文档
              </Link>
              。
            </div>,
            "支持 CAS 身份源接入，支持 CAS 认证后向 SAML SP 推送身份断言。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.1",
      date: "2020/10/24",
      items: [
        {
          title: "MFA 体验升级、支持自定义短信模板",
          items: [
            <div>
              MFA
              体验升级，双因素的安全认证将为你的账户提供更高的安全保护。详情请查看
              <Link
                href="//docs.authing.cn/v2/reference/sdk-for-node/authentication/MfaAuthenticationClient.html"
                rel="noopener noreferrer"
                target="_blank"
              >
                文档
              </Link>
              。
            </div>,
            "自定义短信模板：开发者可以配置第三方短信服务商，实现高效灵活的消息通知服务。",
            "新版开发者中心上线：在开发者中心可以快速体验 SSO 流程、微信扫码登录，此外还有丰富的最佳实践和文档资料。",
            "新版 SDK 上线：Node.js, Python, C#, Java, PHP 新版 SDK 上线，更加规范易用。",
          ],
        },
      ],
    },
    {
      edition: "版本：2.0.0",
      date: "2020/09/17",
      items: [
        {
          title: "Authing 2.0 新版上线",
          items: [
            "架构重新设计，全栈视觉升级。",
            "登录组件自定义，只需五行代码，就可嵌入登录组件，拥有完整的用户管理系统。Authing 2.0 还新增了 30% 的 API，开发者可以灵活选择、组合自己所需的登录流程和功能。",
            "安全性再度提升，AES-256 加密存储、全量 KMS 轮换秘钥、SSL/TLS 协议加密传输。为企业数据资产保驾护航。",
            "权限模型重磅升级，不仅支持基于角色的权限控制，也支持基于策略的访问控制，可以同时为用户、组织、角色授权。",
            "支持 OIDC 身份源配置，可将自有 OIDC 用户中心接入到 Authing 的统一登录平台。",
            "审计日志增加多维度搜索功能，用户的每一次操作都有迹可循。",
            "增加用户自定义字段（ UDF ）功能，可以给用户属性进行个性化扩展。",
          ],
        },
      ],
    },
  ];
  return (
    <div className="log-page">
      <div className="log-banner">
        <img
          src="//files.authing.co/authing-website/changlog-banner.png"
          alt="authing banner"
          className="log-banner-bg"
        />
        <div className="title">Authing Timeline</div>
      </div>
      <div className="log-content">
        {editionData.map((edition) => {
          return (
            <div className="log-edition-item">
              <div className="edition-title-box">
                <div className="edition-title">{edition.date}</div>
                {/* <div className="edition-date">{edition.date}</div> */}
              </div>
              <div className="log-content-box">
                {edition.items.map((item) => {
                  return (
                    <div className="log-content-item">
                      {item.title && (
                        <div className="content-item-title">{item.title}</div>
                      )}
                      {item.items &&
                        (item.items || []).map((info) => {
                          return (
                            <div className="content-item-list">{info}</div>
                          );
                        })}
                      {item.text && (
                        <div className="content-item-text">{item.text}</div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const LogPage = () => {
  return (
    <div>
      <Header mode="dark" />
      <Log />
      <Footer />
    </div>
  );
};
